// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M22.43 4.984c.016.22.016.438.016.657C22.446 12.312 17.291 20 7.868 20c-2.903 0-5.6-.828-7.868-2.266.412.047.809.063 1.237.063 2.396 0 4.6-.797 6.361-2.156-2.252-.047-4.14-1.5-4.79-3.5.317.046.634.078.967.078.46 0 .92-.063 1.349-.172-2.348-.469-4.109-2.5-4.109-4.953V7.03a5.22 5.22 0 002.316.64A5.024 5.024 0 011.047 3.47c0-.938.254-1.797.698-2.547C4.267 3.984 8.058 5.984 12.31 6.203a5.615 5.615 0 01-.127-1.156C12.183 2.266 14.467 0 17.306 0c1.476 0 2.808.61 3.744 1.594A10.182 10.182 0 0024.302.375a5.048 5.048 0 01-2.253 2.781c1.032-.11 2.031-.39 2.951-.781-.698 1-1.57 1.89-2.57 2.61z" />
        </svg>
    );
};

export default React.memo(Twitter);
